import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertifyService } from 'src/app/services/alertify.service';
import { PlanService } from 'src/app/services/plan.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-cambio-plan',
  templateUrl: './cambio-plan.component.html',
  styleUrls: ['./cambio-plan.component.scss']
})
export class CambioPlanComponent implements OnInit {

  registerForm: UntypedFormGroup;
  public dataInput: any;
  public lstPlanes: any;

  constructor(    private usrSvc: UserService,
    private planSvc: PlanService,
    private alertify: AlertifyService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<CambioPlanComponent>) { 
      this.dataInput = data;
      console.log('los datos de ingreso son: ', data);


    }


    ngOnInit(): void {
      this.inicarFormulario();
    }
  
    inicarFormulario() {
      this.registerForm = new UntypedFormGroup({
        planId: new UntypedFormControl('', Validators.required),
        usuarioId: new UntypedFormControl('', Validators.required),
      });
  
      this.planSvc.GetPlanesDropDown().subscribe((disLst) => {
        console.log(disLst);
        this.lstPlanes = disLst;
        this.registerForm.get('usuarioId')?.setValue(this.dataInput.id);
      });
    }
  
    guardar() {
      console.log('guardar cambios disciplina');
      console.log(this.registerForm.value);
  
      this.usrSvc.editarPlanDeUsuario(this.registerForm.value).subscribe((res) => {
        console.log('resultado EditarDisciplina: ', res);
        if (res) {
          this.alertify.success('Plan actualizado correctamente');
          this.dialogRef.close(true);
        } else {
          this.alertify.error('El plan no se ha podido actualizar');
        }
      });
    }

}
